(function (Wishlist, $) {
  var $wishlistButton = $('.wishlist-btn');
  var $wishlistremoveButton = $('.remove-wishlist');
  var $wishlistTile = $('.wishlist-tile-container');
  var $wishlistItemCount = $('.wishlist-item-count');
  var numProductTiles = $wishlistTile.length;
  var wishlist = localStorage.getItem('user_wishlist') || [];
  if (wishlist.length > 0) {
    wishlist = JSON.parse(localStorage.getItem('user_wishlist'));
  } 
  var animateWishlist = function (self) {
    $(self).toggleClass('included');
  };
  var updateWishlist = function (self) {
    var productHandle = $(self).attr('data-product-handle');
    var isRemove = $(self).hasClass('included');
    if (isRemove) {
      var removeIndex = wishlist.indexOf(productHandle);
      wishlist.splice(removeIndex, 1);
      localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
    }
    else {
      wishlist.push(productHandle);
      localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
    }
  }; 
  var activateItemsInWishlist = function () {
    $wishlistButton.each(function () {
      var productHandle = $(this).attr('data-product-handle');
      if (wishlist.indexOf(productHandle) > -1) {
        $(this).addClass('included');
      }
    });
  };  
  var displayOnlyWishlistItems = function () {
    $wishlistTile.each(function () {
      var productHandle = $(this).attr('data-product-handle');
      if (wishlist.indexOf(productHandle) === -1) {
        $(this).remove();
        numProductTiles--;
      }
    });
  };
  var loadWishlist = function () {
    if (window.location.href.indexOf('pages/wishlist') > -1) {
      displayOnlyWishlistItems();
      if (numProductTiles == 0) {
        $('.wishlist-grid--empty-list').addClass('is_visible');
      } else {
        $('.wishlist-grid--empty-list').hide();
      }
    }
  };
  var updateWishlistItemCount = function () {
    if (wishlist) {
      $wishlistItemCount.text(wishlist.length);
    }
  };
  var removeWishlist = function () {
    var productHandle = $('.remove-wishlist').attr('data-product-handle');
    var removeIndex = wishlist.indexOf(productHandle);
    wishlist.splice(removeIndex, 1);
    localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
  };
  var bindUIActions = function () {
    $wishlistButton.click(function (e) {
      e.preventDefault();
      updateWishlist(this);
      animateWishlist(this);
      updateWishlistItemCount(this);
    });
    $wishlistremoveButton.click(function (e) {
      e.preventDefault();
      removeWishlist(this);
      updateWishlistItemCount(this);
      loadWishlist(this);
    });
  };
  Wishlist.init = function () {
    bindUIActions();
    activateItemsInWishlist();
    loadWishlist();
    updateWishlistItemCount();
  };
}(window.Wishlist = window.Wishlist || {}, jQuery, undefined));